module.exports = __webpack_public_path__ + "static/main-5e63e05d6fe33cdc1565b47d2b463064.jpg";